// Render-time shortening of <title> / meta description to Google-friendly lengths (no content edits).
const BRAND_RE = /\s*\|\s*YUCCA(?:\s+Flowers)?\s*$/i;
const CLAUSE_RE = /\s+[—–|]\s+|:\s+|;\s+/;
const TRAILING_RE = /[\s,;:—–\-]+$/;
const CONJUNCTIONS = new Set(["и", "а", "но", "или", "and", "or", "but", "ve", "veya"]);
const FUNCTION_WORDS = new Set([
  "и", "в", "во", "на", "с", "со", "для", "из", "по", "к", "ко", "о", "об", "от", "до", "за", "у", "не", "или", "а", "но", "как", "что", "это",
  "the", "a", "an", "in", "for", "to", "of", "and", "with", "on", "at", "from", "or", "by", "is", "are", "your", "our",
  "ve", "için", "ile", "bir", "de", "da", "veya",
]);

function trimTail(s) {
  let out = s.replace(TRAILING_RE, "");
  for (;;) {
    const words = out.split(/\s+/);
    if (words.length > 1 && FUNCTION_WORDS.has(words[words.length - 1].toLowerCase())) {
      words.pop();
      out = words.join(" ").replace(TRAILING_RE, "");
    } else break;
  }
  return out;
}

function cutAtWord(s, max) {
  if (s.length <= max) return s;
  const words = s.split(/\s+/);
  let best = "", acc = "";
  for (let i = 0; i < words.length - 1; i++) {
    acc = `${acc} ${words[i]}`.trim();
    if (acc.length > max) break;
    const next = words[i + 1].toLowerCase().replace(/[,;:()]/g, "");
    if ((FUNCTION_WORDS.has(next) || /[,;:)]$/.test(words[i])) && acc.length >= max * 0.6) best = acc;
  }
  if (best) return trimTail(best);
  const cut = s.slice(0, max + 1);
  const i = cut.lastIndexOf(" ");
  return trimTail(i > max * 0.5 ? cut.slice(0, i) : cut.slice(0, max));
}

export function stripBrand(title) {
  return (title || "").replace(BRAND_RE, "");
}

export function shortTitle(title, max = 65) {
  if (!title) return title;
  const t = title.replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  const brandMatch = t.match(BRAND_RE);
  const brand = brandMatch ? brandMatch[0].replace(/^\s*/, " ") : "";
  const core = brand ? t.slice(0, t.length - brandMatch[0].length) : t;
  const coreMax = Math.max(25, max - brand.length);
  if (core.length <= coreMax) return core + brand;
  const clauses = core.split(CLAUSE_RE).map((c) => c.trim()).filter(Boolean);
  let acc = "";
  for (const c of clauses) {
    const next = acc ? `${acc} — ${c}` : c;
    if (next.length > coreMax) break;
    acc = next;
  }
  if (acc.length < 15) acc = cutAtWord(clauses[0] || core, coreMax);
  else if (acc.length < coreMax * 0.6 && clauses.length > 1) acc = appendPartial(acc, clauses[clauses.filter((c) => acc.includes(c)).length], coreMax);
  return trimTail(acc.replace(/\s*[([«][^)\]»]*$/, "")) + brand;
}

function appendPartial(acc, clause, coreMax) {
  const room = coreMax - acc.length - 3;
  const words = clause.split(/\s+/);
  let cut = "", n = 0;
  for (let i = 0; i < words.length; i++) {
    const next = `${cut} ${words[i]}`.trim();
    if (next.length > room) break;
    cut = next; n = i + 1;
  }
  if (n >= words.length) return `${acc} — ${clause}`;
  cut = trimTail(cut);
  n = cut ? cut.split(/\s+/).length : 0;
  if (cut.length < 12 || n < 2) return acc;
  const nextW = words[n].toLowerCase().replace(/[,;:()]/g, "");
  const boundary = (FUNCTION_WORDS.has(nextW) && !CONJUNCTIONS.has(nextW)) || /[,;:]$/.test(words[n - 1]) || /\d$/.test(cut);
  return boundary ? `${acc} — ${cut}` : acc;
}

export function shortDescription(desc, max = 160) {
  if (!desc) return desc;
  const d = desc.replace(/\s+/g, " ").trim();
  if (d.length <= max) return d;
  const sentences = d.split(/(?<=[.!?…])\s+/);
  let acc = "";
  for (const s of sentences) {
    const next = acc ? `${acc} ${s}` : s;
    if (next.length > max) break;
    acc = next;
  }
  if (acc.length >= 70) return acc;
  return cutAtWord(d, max - 1) + "…";
}
